

























































































import Vue, { PropType } from "vue";
import timezones from "@/common/assets/timezones.json";
import { CalendarConfiguration } from "@/common/models/CalendarConfiguration";
import { ClickAndCollectConfiguration } from "@/common/models/ClickAndCollectConfiguration";
import { DEFAULT_STORE_TIME_ZONE } from "@/common/constants/Constants";
import { FieldRules } from "@/common/utils/FieldRules";

export default Vue.extend({
  name: "EditClickAndCollect",
  props: {
    clickAndCollectConfig: {
      type: Object as PropType<ClickAndCollectConfiguration>,
      required: true,
    },
    calendarConfig: {
      type: Object as PropType<CalendarConfiguration>,
      required: true,
    },
  },
  data() {
    return {
      timeZoneValues: timezones.map((zone) => {
        return { text: zone, value: zone };
      }),
      defaultTimeZone: DEFAULT_STORE_TIME_ZONE,
      ...FieldRules,
    };
  },
  beforeMount(): void {
    this.calendarConfig.timeZone = this.defaultTimeZone;
  },
});
